<template>
  <functional-calendar
    v-model="calendarData"
    :configs="calendarConfigs"
    v-on:selectedDaysCount="selectedDaysCount"
  ></functional-calendar>
</template>

<script>
import { FunctionalCalendar } from "vue-functional-calendar";

export default {
  name: "DateSelector",
  components: {
    FunctionalCalendar,
  },
  methods: {
    selectedDaysCount() {
      let start = this.calendarData.dateRange.start.split("/");
      let end = this.calendarData.dateRange.end.split("/");

      let selectStart = new Date(
        parseInt(start[2]),
        parseInt(start[1]) - 1,
        parseInt(start[0]),
        0,
        0,
        0,
        1
      ).getTime();

      let selectEnd = new Date(
        parseInt(end[2]),
        parseInt(end[1]) - 1,
        parseInt(end[0]),
        23,
        59,
        59,
        999
      ).getTime();

      if (selectStart <= selectEnd) {
        this.$emit("update:dates", [selectStart, selectEnd]);
      }
    },
  },
  data() {
    return {
      calendarData: {},
      calendarConfigs: {
        sundayStart: false,
        dateFormat: "dd/mm/yyyy",
        isDatePicker: false,
        isDateRange: true,
      },
    };
  },
};
</script>
